import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import cardImg1 from "../../../assets/v3/images/card-img-1.svg";
import cardImg2 from "../../../assets/v3/images/card-img-2.svg";

import { FiArrowRight } from "react-icons/fi";

import Config from '../../../core/config/';
import { makeRequest } from '../../../core/services/v1/request';

import Countdown from 'react-countdown';

function HomeMarket(props) {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const Completionist = () => <span>You are good to go!</span>;

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      return <Completionist />;
    } else {
      return <div className="timer">
        <p className="timer-input">
          {formatTime(days)} <span>d</span>
        </p>
        :
        <p className="timer-input">
          {formatTime(hours)} <span>h</span>
        </p>
        :
        <p className="timer-input">
          {formatTime(minutes)} <span>m</span>
        </p>
        :
        <p className="timer-input">
          {formatTime(seconds)} <span>s</span>
        </p>
      </div>
    }
  };

  const [timeLeft, setTimeLeft] = useState({
    hours: 7,
    minutes: 26,
    seconds: 9,
  });

  const formatTime = (value) => String(value).padStart(2, "0");

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTimeLeft((prevTime) => {
        const { hours, minutes, seconds } = prevTime;

        if (hours === 0 && minutes === 0 && seconds === 0) {
          clearInterval(timerInterval);
          return prevTime;
        }

        let newSeconds = seconds - 1;
        let newMinutes = minutes;
        let newHours = hours;

        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }

        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }

        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds,
        };
      });
    }, 1000);

    return () => clearInterval(timerInterval);
  }, []);

  const [upcomingMarkets, setUpcomingMarkets] = useState([]);
  const [latestMarkets, setLatestMarkets] = useState([]);
  const [gainerMarkets, setGainerMarkets] = useState([]);
  const [loserMarkets, setLoserMarkets] = useState([]);

  async function getMarketsInit(data = {}) {
    console.log("getMarketsInit");
    await getMarkets({ page: "home", filter: "upcoming" });
    await getMarkets({ page: "home", filter: "latest" });
    await getMarkets({ page: "home", filter: "topGainers" });
    await getMarkets({ page: "home", filter: "topLosers" });
  }
  async function getMarkets(data = {}) {
    try {
      const params = {
        url: `${Config.V1_API_URL}trade/getMarkets`,
        method: 'POST',
        data
      }
      const response = (await makeRequest(params));
      if (response.status && response.data) {
        if(data.filter == "upcoming") {
          setUpcomingMarkets(response.data)
        } 
        else if(data.filter == "latest") {
          setLatestMarkets(response.data)
        }
        else if(data.filter == "topGainers") {
          setGainerMarkets(response.data)
        } else if(data.filter == "topLosers") {
          setLoserMarkets(response.data)
        }
      }
    } catch (err) {}
  }

  useEffect(() => {
    getMarketsInit();
  }, []);

  const hotListData = [
    {
      id: 1,
      title: "New"
    },
    {
      id: 1,
      title: "Top Gainers"
    },
    {
      id: 1,
      title: "Top Losers"
    }
  ];

  return (
    <section className="home-section-2">
      {upcomingMarkets && upcomingMarkets.length > 0 ? <>
      <h2 className="h-text-2">Upcoming Markets</h2>
      <div className="row g-4 w-100 h-100">
        {upcomingMarkets.map((card) => (
          card.fromCurrency ?
          <div className="col-lg-6" key={"upcMar-"+card.id}>
            <div className="crypto-card">
              <div className="crypto-card-head">
                <div className="crypto-card-head-left">
                  {card.fromCurrency && card.fromCurrency.image ?
                  <img
                    width={70}
                    height={70}
                    src={card.fromCurrency.image}
                    className="card-img"
                    alt={`Crypto_Card_Image_${card.id}`}
                  />:<></>}
                  <div className="crypto-card-head-left-content">
                    <div className="crypto-card-head-left-text">
                      <p className="p-text-2">{card.fromCurrency.currencySymbol}</p>
                      <span className="s-text-2">{card.fromCurrency.currencyName}</span>
                    </div>
                    {/* <button className="listing-btn">{card.buttonText}</button> */}
                  </div>
                </div>
                {/* <button className="subscribe-btn">
                  <p className="mobile-hide">Trade</p> <FiArrowRight />
                </button> */}
              </div>
              <div className="crypto-card-body">
                <p className="p-text-3">Coming Soon</p>
                <Countdown
                  date={card.statusActiveFrom}
                  renderer={renderer}
                />
              </div>
            </div>
          </div> : ""
        ))}
      </div>
      </>: <></>}
      <div className="row g-4 w-100 h-100">
        {hotListData.map((card) => {
          const list = card.title == "New" ? latestMarkets : card.title == "Top Gainers" ? gainerMarkets : card.title == "Top Losers" ? loserMarkets : [];
          return <div key={"hld-"+card.id} className="col-lg-4">
            <div className="hot-list-card">
              <div className="hot-list-card-head">
                <span className="s-text-3">{card.title}</span>
              </div>
              <div className="hot-list-card-body">
                {list && list.length > 0 ? list.map((item, index) => (
                  <div key={index} className="hot-list-card-body-list" onClick={() => navigate("/spot/"+item.fromCurrency.currencySymbol+"_"+item.toCurrency.currencySymbol)}>
                    <div className="hot-list-card-body-list-left">
                      <img
                        src={item.fromCurrency.image}
                        width={30}
                        height={30}
                        alt={`Token_Image_${item.fromCurrency.currencySymbol}`}
                      />
                      <div className="hot-list-card-body-list-left-text">
                        <p className="p-text-4">{item.fromCurrency.currencySymbol}</p>
                        <span className="s-text-4">{item.fromCurrency.currencyName}</span>
                      </div>
                    </div>
                    <div className="hot-list-card-body-list-right">
                      <p className="p-text-5">{item.price != undefined ? item.price.toFixed(8) : 0}</p>
                      <span
                        className={`${
                          item.danger || (item.change && item.change.toFixed(4) > 0) ? "s-text-5" : "s-text-5 danger-text"
                        }`}
                      >
                        {item.change != undefined ? item.change.toFixed(4) : 0}
                      </span>
                    </div>
                  </div>
                )) : <div>
                  No data found.
                </div>}
              </div>
            </div>
          </div>
          })}
      </div>
    </section>
  );
}

export default HomeMarket;
